import React from 'react';
import EconomicsPanel from '../../components/economics/EconomicsPanel';
import { useProject } from './ProjectContext';

/**
 * CBA & ROI analysis tab. Lifted verbatim from ProjectDetailPage.tsx L4437-4441 —
 * `project` was guarded there with `project &&` because the monolith could render
 * before load; here it's always non-null (see ProjectContext).
 */
const EconomicsTab: React.FC = () => {
  const { project } = useProject();

  return (
    <div className="space-y-6 animate-fade-in">
      <EconomicsPanel projectId={project.id} projectName={project.name} />
    </div>
  );
};

export default EconomicsTab;
